import { render, staticRenderFns } from "./UploadAudio.vue?vue&type=template&id=219ded32&scoped=true&"
import script from "./UploadAudio.vue?vue&type=script&lang=js&"
export * from "./UploadAudio.vue?vue&type=script&lang=js&"
import style0 from "./UploadAudio.vue?vue&type=style&index=0&id=219ded32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ded32",
  null
  
)

export default component.exports